export default {
      id: "ic_check_filled-usage",
      viewBox: "0 0 12 13",
      url: "/" + "images/icons.3.109.2.svg#ic_check_filled-usage",
      toString: function () {
        return this.url;
      }
    }